<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
      
      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
          <span :class="['icon hero-icon '+icon+ ' '+online]"></span>
        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.trunkName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_content">
             	<ul class="h-topo_tableheight">
             		<li>{{$t('Topo.trunkId')}}: {{devInfo.id}} </li>
	              	<li>{{$t('Topo.trunkCode')}}: {{typeCode}} </li>        
	              	<li>{{$t('Topo.devSoftVersion')}}:{{devInfo.displaySoftwareVersion}}</li>
	            </ul>
          </div>
        </div>
        <!-- 
        <div class="h-topo_btnbox">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
        </div>-->
        
      </div>
    </div>

	<!-- “告警弹窗展示” -->
	<!-- 
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>-->
   </div>
</template>
<script>

	import CustomDialog from "../../components/common/CustomDialog";
	import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
	import { EventBus } from '../../plugins/eventBus';

	export default {
	name: "TrunkPanelBoardShow",
	components: {
	    CustomDialog,
	    AlarmShowDialog
	},
	data() {
		return {
			typeCode: "",
			devInfo: {},
			see: false,
			seeBottom: false,
			id: "",
			type: "",
			icon: "",
			online: "",
			PositionXY: "",
		};
	},
  props: ["trunkShowObj"],
  methods: {
    panelBoardGetData() {
      this.axios.get(`/lte/ems/topo/trunk/findTrunk/${this.id}`)
        .then(response => {
	          if (response.data.errorCode === 'SUCCESS') {
				this.devInfo = response.data.resultVal;
				this.queryTrunkType(this.devInfo.typeCode);
	          }
        });
    },

    // 去后台查集群类型
    queryTrunkType(typeCode) {
      const This = this;
      This.$axios.get('/lte/ems/topo/trunk/findTrunkTypeById/' + typeCode).then(response => {
          if(response.data === undefined){
            return;
          }
          if (response.data.errorCode === 'SUCCESS') {
            This.typeCode = response.data.resultVal.nameKey;   
            this.icon = response.data.resultVal.icon;


          } else if(response.status === 401) {
            EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
      });
    },
    click() {
      this.seeBottom = !this.seeBottom;
    },

  },
  
  alarmShowOperation() {
      var alarmId=this.id
      let ids = [alarmId];
      this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
        if (!response.data) {
          return;
        }
        if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
          if (response.data && response.data.resultVal.length > 0) {
            ids = ids.concat(response.data.resultVal);
          }
        } else if(response.status === 401) {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        this.$refs.alarmDetailDialog.beforeMount(ids);
        this.$refs.oprDialog.show();
      });
  },
    
  mounted() {},
  watch: {
    //父子动态传值
    trunkShowObj: {
      handler: function(newVal, oldVal) {
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;
        this.type = newVal.typeObj;
        if(newVal.onlineObj===1){
        	this.online='h-pm-iconOnline';
        }       
        else if(newVal.onlineObj===0) {
        	this.online='h-pm-iconOffline';
        }
        
        this.PositionXY = newVal.PositionXY;	//-- panel position
        this.panelBoardGetData();
       
      },
      deep: true
    }
  }
};
</script>
<style>
</style>
